// extracted by mini-css-extract-plugin
export default {"back_btn_row":"Navigation_back_btn_row__bEX7B","back_btn":"Navigation_back_btn__yIW4n"};